<template>
    <span class="weather-header__month-year">{{ month }} {{ year }}</span>
</template>

<script setup>
const props = defineProps({
    providedMonth: {
        type: Number,
        required: true,
    },
})

const month = ref('')
const year = ref('')

function getMonthYear() {
    const date = new Date()
    // Grab the current month number
    const currentMonth = date.getMonth()
    // Give the provided month a full name instead of a number
    date.setDate(1)
    date.setMonth(props.providedMonth)
    month.value = date
        .toLocaleString('en-EN', { month: 'long' })
        .toUpperCase()
    // Check if the current month is greater than the provided month
    // If so, we want to display the next year, not the current year
    if (currentMonth > props.providedMonth) {
        year.value = date.getFullYear() + 1
    } else {
        year.value = date.getFullYear()
    }
}

getMonthYear()
</script>
